import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'util/i18n';

import { HISTORY, HISTORY_RESIDENCE } from 'config/formSections/history';
import { formConfig } from 'config/forms';
import { findTimelineGaps, getApplicantRequiredDuration } from 'helpers/date';

import connectSubsection from 'components/Section/shared/SubsectionConnector';

import Field from 'components/Form/Field';
import Show from 'components/Form/Show';
import { SF852013 } from 'constants/formTypes';
import { isPVQForm } from 'helpers/form';
import ResidenceSummaryProgress from './ResidenceSummaryProgress';
import ConnectedResidence from './Residence';

const sectionConfig = {
  key: HISTORY_RESIDENCE.key,
  section: HISTORY.name,
  subsection: HISTORY_RESIDENCE.name,
};

const ResidenceWrapper = function (props) {
  const {
    applicantBirthdate, formType, errors, data
  } = props;

  const years = formType && formConfig[formType] && formConfig[formType].HISTORY_RESIDENCE_YEARS;

  const { coverage, requiredYears } = getApplicantRequiredDuration({
    requiredDuration: { years }, applicantBirthdate, formType, type: 'residence'
  });

  const formName = formType;
  const isPVQ = isPVQForm(formType);
  const validResidenceDates = data.List && data.List.items
    ? data.List.items
      .filter((i) => {
        if (!i?.Item?.Dates) { return false; }
        if (!errors || !errors.length) { return true; }
        if (errors.filter((e) => e.indexOf(i.uuid) > -1).length > 0) { return false; }
        return true;
      })
      .map((i) => i.Item.Dates)
    : [];

  const gaps = findTimelineGaps(coverage, validResidenceDates);

  return (
    <div>
      {isPVQ ? (
        <h1 className="section-header">{i18n.t('history.pvq.residence.title')}</h1>
      ) : (
        <h1 className="section-header">{i18n.t('history.residence.title')}</h1>
      )}

      <Field
        title={i18n.t('history.residence.info', { years: requiredYears })}
        titleSize="h3"
        optional
        className="no-margin-bottom"
      >
        {isPVQ
          ? [
            i18n.m('history.pvq.residence.info2a'),
            i18n.m('history.pvq.residence.info2b'),
            i18n.m('history.pvq.residence.info2c'),
            i18n.m('history.pvq.residence.info2d'),
            i18n.m('history.pvq.residence.info2e'),
            i18n.m('history.pvq.residence.info2f'),
          ] : [
            i18n.m('history.residence.info2'),
            i18n.m('history.residence.info3a'),
            i18n.m('history.residence.info3b'),
            i18n.m('history.residence.info3c'),
            i18n.m('history.residence.info3d')
          ]}
      </Field>

      <span id="scrollToHistory" />

      <ResidenceSummaryProgress
        years={years}
        dates={validResidenceDates}
        applicantBirthdate={applicantBirthdate}
        formType={formType}
      />

      <ConnectedResidence
        realtime
        scrollToTop="scrollToHistory"
        totalYears={requiredYears}
        gaps={gaps}
        required={false}
      />

      <Show when={gaps && gaps.length > 0}>
        <div className="not-complete">
          <hr className="section-divider" />

          <Field
            title={i18n.t('history.residence.heading.exiting')}
            titleSize="h4"
            optional
            className="no-margin-bottom"
          >
            {i18n.m('history.residence.para.exiting', { years: requiredYears, formName })}
          </Field>
        </div>
      </Show>
    </div>
  );
};

/* eslint react/forbid-prop-types: 0 */
ResidenceWrapper.propTypes = {
  applicantBirthdate: PropTypes.object,
  formType: PropTypes.string.isRequired,
  data: PropTypes.object,
  errors: PropTypes.array,
  required: PropTypes.bool,
};

ResidenceWrapper.defaultProps = {
  applicantBirthdate: null,
  data: {},
  errors: [],
  required: false,
};

export default connectSubsection(ResidenceWrapper, sectionConfig);
